module.exports = __webpack_public_path__ + "static/media/xk.e62eb493.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/xk.svg
// module id = 290
// module chunks = 0